import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`I am a web developer 1.5+ years experience in web development.`}</h4>
    <p>{`I have knowledge of Javascript Python.I work with Nodejs, Adonisjs, Reactjs, Django, Graphql, TypeScript, Gatsby.I have knowledge of cloud like Heroku, Digital Ocean, Google Cloud, Aws, Netlify. I work with Digital Ocean, Firebase, Netlify. I attend GDG 2020 and participate/contribute in Hacktoberfest18 and Hacktoberfest19.daily i expand my skill and try to update my self with trending techs.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      